import React from 'react';
import features1 from './assets/images/features-1.png';
import features2 from './assets/images/features-2.png';
import features3 from './assets/images/features-3.png';
// import ReactCardSlider from 'react-card-slider-component';

const Features = () => {


    return (
        // <!-- Features -->

        <section  className="features section">
          <div className="container">
            <p className="section__para one" data-aos="fade-up">Youbie</p>
            <h2 className="heading__1" data-aos="fade-up">Features</h2>
            <p className="section__para two" data-aos="fade-up">
              Ecosystem & Features
            </p>
            
            <section className=''
             >
         
              <ul className="grid lg:grid-cols-3  gap-12">
  
              
                    <div className="feature-box" data-aos="fade-up">
                    <div className="card w-80">
                      <div className="feature-box__img one">
                        <img
                          src={features1}
                          alt="Deposit Methods"
                          className="img-fluid"
                          width="195"
                          height="233"
                        />
                      </div>
                      <h3 className="feature-box__title">Deposit Methods</h3>
                      <p className="feature-box__text">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua.
                      </p>
                      <a href="#" className="feature-box__link ">Read More</a>
                      </div>
                    </div>
          



          
                    <div className="feature-box" data-aos="fade-up">
                    <div className="card w-80">
                      <div className="feature-box__img two">
                        <img
                          src={features2}
                          alt="Low Creator Fees"
                          className="img-fluid"
                          width="195"
                          height="233"
                        />
                      </div>
                      <h3 className="feature-box__title">Low Creator Fees</h3>
                      <p className="feature-box__text">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua.
                      </p>
                      <a href="#" className="feature-box__link">Read More</a>
                      </div>
                    </div>
             


               <div className="feature-box" data-aos="fade-up">
                    <div className="card w-80">
                      <div className="feature-box__img three">
                        <img
                          src={features3}
                          alt="NFT Marketplace"
                          className="img-fluid"
                          width="195"
                          height="233"
                        />
                      </div>
                      <h3 className="feature-box__title">NFT Marketplace</h3>
                      <p className="feature-box__text">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua.
                      </p>
                      <a href="#" className="feature-box__link">Read More</a>
                    </div>
                    </div>
           
                </ul>
            
            </section>
          </div>
        </section>

        // <!-- Features -->
    );
};

export default Features;